import  api from "./api"


export default class ReadService {
    static fetchLocalitiesByProject(project_id){ return api.get(`localities/list/${project_id}`).catch(e=>console.log(e))}
    static fetchModules(){return api.get('core/lusplan/project-type/list').catch(e=>console.log(e))}
    static fetchCCRDraftData(project_id, village_id,flag) {return api.get(`collect/list/draft/${project_id}/${village_id}/${flag}`).catch(e=>{ console.log(e);})}
    static fetchProjectVillages(project_id){return api.get(`workshop/list/project/${project_id}/villages`).catch(e=>console.log(e))}
    static fetchDeedPlanInfo(project_id) {return api.get(`spatial/deedplan/info/${project_id}`).catch(e=>{ console.log(e);})}
    static fetchPlots(project_id,deedplan,status) {return api.get(`spatial/${project_id}/plots/${deedplan}/${status}`).catch(e=>{ console.log(e);})}
    static fetchParties(project_id) {return api.get(`spatial/${project_id}/list/parties`).catch(e=>{ console.log(e);})}
    static fetchCCRODataByStage(project_id, stage,village_id) {return api.get(`projects/parcels/${project_id}/${stage}`).catch(e=>{ console.log(e);})}
    static searchCCRODataByStage(project_id, search,village_id) {return api.get(`projects/parcels/search/${project_id}/${search}`).catch(e=>{ console.log(e);})}
    static fetchDocuments(parcel_id) {return api.get(`collect/ccro/documents/${parcel_id}`)}
    static fetchDraftData(project_id){return api.get(`spatial/${project_id}/list/draft`).catch(e=>{ console.log(e);})}
    static fetchRemark(parcel_id){ return api.get(`collect/ccro/remarks/${parcel_id}`)}
    static fetchItems(vid=0){return api.get(`admin/items/list/${vid}`).catch(e=>{ console.log(e);})}
    static fetchHamlets(pid) {return api.get(`locality/${pid}/hamlet/list`).catch(e=>{ console.log(e);})}
    static fetchQuestionnaires(data) {return api.post(`workshop/list/questionnaire`,data).catch(e=>{console.log(e)})}
    static migrate(){ return api.get('spatial/migrate').catch(e=>{console.log(e)})}

    // service to read register data for ccro per village
    

    static getParcelSpatial(parcel_id) { return api.get(`spatial/parcel/${parcel_id}`).catch(e=>{console.log(e)})}

    static generateDocument(param) { return api.post('collect/ccro/generate-doc',param) }
}